import { ToastContainer } from "react-toastify";
import baseStyles from "src/global.module.css";

const ErrorMessageToast = () => {
    return (
        <ToastContainer
            className={baseStyles.z_index_infinity}
            position="bottom-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            closeButton={false}
        />
    );
};

export default ErrorMessageToast;
